import { environment } from "../../environments/environment";

export class Urls {
  public static baseApiUrl = `${environment.baseurl}`;

  // Common
  public static getCity = Urls.baseApiUrl + "getcitylist";
  public static getDocumentsByType = Urls.baseApiUrl + "getDocumentsByType";
  public static getState = Urls.baseApiUrl + "getstatelist";
  public static getFiles = Urls.baseApiUrl + "getDocumentsByType";
  public static getPartnerFiles = Urls.baseApiUrl + "getPartnerDocumentByType";
  
  //Statutory Documents
  public static getStatutoryDocs = Urls.baseApiUrl + 'statutorydocument';
  public static getMonthsBySection = Urls.baseApiUrl + 'getMonth';
  public static getYearBySection = Urls.baseApiUrl + 'getYear';

  // Home page urls
  public static getTop3Funds = Urls.baseApiUrl + "getFundDetails";

  // Header
  public static getBanners = Urls.baseApiUrl + "getBanners";
  public static getLatestNav = Urls.baseApiUrl + "getLatestNav";

  // Write to us
  public static postWriteUs = Urls.baseApiUrl + "postWriteToUs";
  public static getReasons = Urls.baseApiUrl + "getReasons";

  // Nav & Dividends
  public static getSchemeNav = Urls.baseApiUrl + "getScheme";
  public static getPlanNav = Urls.baseApiUrl + "getPlan";

  public static getSchemeDiv = Urls.baseApiUrl + "getSchemeforDividend";
  public static getPlanDiv = Urls.baseApiUrl + "getPlanforDividend";

  public static getCurrentNav = Urls.baseApiUrl + "getCurrentNav";
  public static getHistoricNav = Urls.baseApiUrl + "getNav";
  public static getCurrentDividend = Urls.baseApiUrl + "getCurrentDividend";
  public static getHistoricDividend = Urls.baseApiUrl + "getDividends";

  // Request call back
  public static postRequestCallBack = Urls.baseApiUrl + "postRequestCallBack";

  // FAQs
  public static getFaqs = Urls.baseApiUrl + "getFaqs";

  // Careers
  public static postCareers = Urls.baseApiUrl + "careers";
  public static getCareersDeparment = Urls.baseApiUrl + "getDepartment";
  public static getCareersLocation = Urls.baseApiUrl + "getLocation";
  public static getCareersJOB = Urls.baseApiUrl + "adminportal/getCareerJobs";
  
  // Contact Us
  public static getContactPerson =
    Urls.baseApiUrl + "getAcceptanceByCityAndState";

  // Footer
  public static postContactDetails = Urls.baseApiUrl + "postCustomerContact";

  // Footer --Help
  public static getKarvyBranches = Urls.baseApiUrl + "getKFinDetails";
  public static getAmcBranches = Urls.baseApiUrl + "getAMCBranchDetails";
  public static getYourAdvisor = Urls.baseApiUrl + "getLocateAdvisorDetails";

  // Product Details
  public static getProductDetails = Urls.baseApiUrl + "getProductDetails";

  // Investor Page
  public static getInvestorVideo = Urls.baseApiUrl + "getInvestorVideo";

  // STATUTORY => EXECUTIVE REMUNERATION
  public static addStatutory = Urls.baseApiUrl + "statutory";

  //Downloads => Asset Allocation 
  public static readAssetAllocation = Urls.baseApiUrl + "asset";
  public static readDigitalFactsheet = Urls.baseApiUrl + "digitalfactsheet";

  // ARTICLES - CEO, LATEST NEWS, MEDIA
  public static readArticles = Urls.baseApiUrl + "adminportal/getArticles";
  public static getYear = Urls.baseApiUrl + "getYear";
  public static getMonths = Urls.baseApiUrl + "getMonth";
  public static getCategories = Urls.baseApiUrl + 'getCategories';

  // INVESTOR-CHARTER - Complaint Lodge
  public static getComplainceCategories = Urls.baseApiUrl + "complaint/categories";
  public static lodgeComplaint = Urls.baseApiUrl + "complaint/lodge";

  //Process-Unclaimed Redemption and IDCW
  public static unclaimedRedemptionDetails = Urls.baseApiUrl +"unclaimed/redemption";
}
